// extracted by mini-css-extract-plugin
export default {"l":"UserPhoto_l__vXHII","error":"UserPhoto_error__VFL+8","oval":"UserPhoto_oval__HpR07","m":"UserPhoto_m__AUIkh","s":"UserPhoto_s__aMeLp","img":"UserPhoto_img__LaQ9O"};